module.exports = __webpack_public_path__ + "static/media/whyUsBanner.c2f195cf.png";